import { Col, Row, RowProps, UiIcon, UiImage, UiText } from "~/components/elements";
import images from "~/assets/img";
import React from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { HeadshotStyleResultApi, PhotoshootType } from "~/types/models/dashboard";

interface StyleListItemForDetailProps extends Omit<RowProps, "onSelect"> {
  headshotStyle: HeadshotStyleResultApi;
  filterable: boolean;
  onSelect?: (hss: HeadshotStyleResultApi) => void;
  onClickClose?: (hss: HeadshotStyleResultApi) => void;
  photoshootType?: PhotoshootType;
}

export function StyleListItemForDetail({
  headshotStyle,
  filterable,
  onSelect,
  onClickClose,
  photoshootType,
  ...rest
}: StyleListItemForDetailProps) {
  // const outfitData = useSelector((state: RootState) => state.dashboard.outfitData);
  const onClick = (e: React.FormEvent) => {
    if (!filterable) {
      e?.preventDefault();
      return;
    }
    onSelect?.(headshotStyle);
  };
  // const outfit = outfitData.find(of => of.name === headshotStyle.clothing?.value);
  // const hsStyle = outfit?.headshot_styles.find(hs => hs.name === headshotStyle.bg?.value);
  const maleImg = headshotStyle.headshot_style?.man_preview_photo_url;
  const femaleImg = headshotStyle.headshot_style?.woman_preview_photo_url;

  const renderPreviewImage = () => <Row ml={2} />;
  // if (photoshootType === "two_person") {
  //   return <Row ml={2} />;
  // }

  // if (maleImg && femaleImg) {
  //   return (
  //     <Row mr={2} w="4rem" minW="4rem">
  //       <>
  //         <UiImage src={maleImg} borderLeftRadius="0.5rem" h="2.625rem" objectFit="cover" objectPosition="top" />
  //         <UiImage src={femaleImg} borderRightRadius="0.5rem" h="2.625rem" objectFit="cover" objectPosition="top" />
  //       </>
  //     </Row>
  //   );
  // }
  // return (
  //   <Row mr={2} w="4rem" minW="4rem">
  //     <UiImage src={images.snapglogo} borderRadius="0.5rem" h="2.625rem" objectFit="cover" />
  //   </Row>
  // );
  return (
    <Row
      rounded="xl"
      bg={headshotStyle.is_selected ? "lightblue" : "white"}
      borderWidth="1px"
      borderColor={headshotStyle.is_selected ? "blue" : "transparent"}
      p={2}
      w="full"
      minW="14.9rem"
      _hover={{ cursor: filterable ? "pointer" : "default" }}
      onClick={onClick}
      {...rest}
    >
      {renderPreviewImage()}
      <Col flexGrow={1} justifyContent="space-between">
        <UiText vr="title2" noOfLines={1}>
          {headshotStyle.headshot_style?.background_name}
        </UiText>
        <UiText vr="body2" color="neutral.gray400" noOfLines={1}>
          {photoshootType === "two_person" ? "Outfits are auto generated" : headshotStyle.headshot_style?.outfit_name}
        </UiText>
      </Col>
      {onClickClose && (
        <Col justifyContent="center" onClick={() => onClickClose?.(headshotStyle)} _hover={{ cursor: "pointer" }}>
          <UiIcon as={AiOutlineCloseCircle} boxSize={6} color="neutral.gray300" />
        </Col>
      )}
    </Row>
  );
}
